import { collection, doc, getDoc, getDocs, query, where } from 'firebase/firestore';
import { DEFAULT_TENANT_ID, type AppUser } from '@kawai/shared';
import { db } from '../firebase.js';

const USERS_COL = 'users';

/**
 * 全顧客プロフィールを取得する（promo admin 用）。
 *
 * Firestore Rules `users/{uid}` は admin に対し `belongsToMyTenant()` で read 許可。
 * sort / 検索 / セグメント絞り込みはクライアント側（純関数 `filterUsersBySegment`）で実施する。
 *
 * `uid` フィールドが古いドキュメントで欠落していても Firestore document id に
 * フォールバックする（reservation 側 repositories/users.ts と同じ作法）。
 */
export async function fetchAllUsers(
  tenantId: string = DEFAULT_TENANT_ID,
): Promise<AppUser[]> {
  const snap = await getDocs(
    query(collection(db, USERS_COL), where('tenantId', '==', tenantId)),
  );
  return snap.docs.map((d) => {
    const data = d.data() as Partial<AppUser>;
    return {
      ...data,
      uid: data.uid ?? d.id,
    } as AppUser;
  });
}

/**
 * 指定 uid の顧客プロフィールを取得する。存在しなければ null。
 */
export async function fetchUserById(uid: string): Promise<AppUser | null> {
  const ref = doc(db, USERS_COL, uid);
  const snap = await getDoc(ref);
  if (!snap.exists()) return null;
  const data = snap.data() as Omit<AppUser, 'uid'> & { uid?: string };
  return {
    ...data,
    uid: data.uid ?? uid,
  };
}
